import { useCallback, useEffect } from "react";

import { isUserInput } from "@skilitics/designer-ui-components";
import { useHidePanels, useKeyboardShortcutsVisible } from "@skilitics/nautilus-core-designer";

export const useAppKeyboardShortcuts = () => {
  const [, setHidePanels] = useHidePanels();
  const [, setKeyboardShortcutsVisible] = useKeyboardShortcutsVisible();

  const handleKeyDown = useCallback(
    (e: globalThis.KeyboardEvent) => {
      if (isUserInput(e.target)) return;

      if (e.key === "?") {
        e.stopPropagation();
        setKeyboardShortcutsVisible((prev) => !prev);
        return;
      }
      if ((e.metaKey || e.ctrlKey) && e.key === "\\") {
        e.stopPropagation();
        e.preventDefault();
        setHidePanels((prev) => !prev);
        return;
      }
    },
    [setHidePanels, setKeyboardShortcutsVisible],
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);
};
